import React from 'react';
import {Link} from 'react-router-dom';
import type {DeerDecisionHistory} from '../../services/photos/animals';
import {deerReviewPath} from '../../services/photos/animalNavigation';

export default function PhotoAnimalDecisionEvidence({decision,returnTo}:{decision:DeerDecisionHistory['decisions'][number];returnTo:string}){
 return <ul className="space-y-2 mt-3">{decision.observations?.map(o=><li key={o.target.binding}>
  <p className="break-words">{o.beforeAnimal?.name||'Unassigned'} → {o.afterAnimal?.name||'Unassigned'}</p>
  {o.available?<Link className="inline-block min-h-11 pt-2 text-usda-700" to={deerReviewPath(o.target.photoId,o.target.context,o.target.subjectId,returnTo)+'&binding='+encodeURIComponent(o.target.binding)}>Open reviewed evidence</Link>:<p className="text-xs text-stone-500">The earlier evidence cannot be reused with the current photo.</p>}
 </li>)}</ul>;
}
